// extracted by mini-css-extract-plugin
export var BusinessSupport = "BusinessSupport-module--BusinessSupport--EvGCy";
export var BusinessSupport_container = "BusinessSupport-module--BusinessSupport_container--9kAVA";
export var BusinessSupport_header = "BusinessSupport-module--BusinessSupport_header--QZ8Fp";
export var BusinessSupport_header_text = "BusinessSupport-module--BusinessSupport_header_text--QSQYT";
export var BusinessSupport_header_title = "BusinessSupport-module--BusinessSupport_header_title--cUbnV";
export var BusinessSupport_image = "BusinessSupport-module--BusinessSupport_image--pmWA5";
export var BusinessSupport_image_meta = "BusinessSupport-module--BusinessSupport_image_meta--rfCbK";
export var BusinessSupport_image_meta_text = "BusinessSupport-module--BusinessSupport_image_meta_text--O114V";
export var Testimonial_header = "BusinessSupport-module--Testimonial_header--zMKvL";
export var container = "BusinessSupport-module--container--LyCTF";
export var gatsbyImageWrapperConstrained = "BusinessSupport-module--gatsby-image-wrapper-constrained--HE4EP";
export var gridSpan1010 = "BusinessSupport-module--grid-span-10-10--hegyF";
export var gridSpan1011 = "BusinessSupport-module--grid-span-10-11--epZDo";
export var gridSpan102 = "BusinessSupport-module--grid-span-10-2--YxhIg";
export var gridSpan103 = "BusinessSupport-module--grid-span-10-3--TtGdj";
export var gridSpan104 = "BusinessSupport-module--grid-span-10-4--4l9a9";
export var gridSpan105 = "BusinessSupport-module--grid-span-10-5--u5xel";
export var gridSpan106 = "BusinessSupport-module--grid-span-10-6--279+f";
export var gridSpan107 = "BusinessSupport-module--grid-span-10-7--b9uZJ";
export var gridSpan108 = "BusinessSupport-module--grid-span-10-8--YKjiN";
export var gridSpan109 = "BusinessSupport-module--grid-span-10-9--r6RM1";
export var gridSpan110 = "BusinessSupport-module--grid-span-1-10--XuMEH";
export var gridSpan111 = "BusinessSupport-module--grid-span-1-11--BhXzh";
export var gridSpan1110 = "BusinessSupport-module--grid-span-11-10--+-G7X";
export var gridSpan1111 = "BusinessSupport-module--grid-span-11-11--h7eZR";
export var gridSpan112 = "BusinessSupport-module--grid-span-11-2--RheYS";
export var gridSpan113 = "BusinessSupport-module--grid-span-11-3--MGx9-";
export var gridSpan114 = "BusinessSupport-module--grid-span-11-4--h1NYs";
export var gridSpan115 = "BusinessSupport-module--grid-span-11-5--z9+VY";
export var gridSpan116 = "BusinessSupport-module--grid-span-11-6--6ACSX";
export var gridSpan117 = "BusinessSupport-module--grid-span-11-7--jWVj2";
export var gridSpan118 = "BusinessSupport-module--grid-span-11-8--yjQ7E";
export var gridSpan119 = "BusinessSupport-module--grid-span-11-9--6UIp0";
export var gridSpan12 = "BusinessSupport-module--grid-span-1-2--v6gXN";
export var gridSpan1210 = "BusinessSupport-module--grid-span-12-10--8T4xk";
export var gridSpan1211 = "BusinessSupport-module--grid-span-12-11--ai2FL";
export var gridSpan122 = "BusinessSupport-module--grid-span-12-2--h6XPj";
export var gridSpan123 = "BusinessSupport-module--grid-span-12-3--Gcy05";
export var gridSpan124 = "BusinessSupport-module--grid-span-12-4--hWLms";
export var gridSpan125 = "BusinessSupport-module--grid-span-12-5--APa6h";
export var gridSpan126 = "BusinessSupport-module--grid-span-12-6--vzLj7";
export var gridSpan127 = "BusinessSupport-module--grid-span-12-7--5zJJL";
export var gridSpan128 = "BusinessSupport-module--grid-span-12-8--0QDAo";
export var gridSpan129 = "BusinessSupport-module--grid-span-12-9--Ca2mB";
export var gridSpan13 = "BusinessSupport-module--grid-span-1-3--VOM72";
export var gridSpan14 = "BusinessSupport-module--grid-span-1-4--V7FIj";
export var gridSpan15 = "BusinessSupport-module--grid-span-1-5--g4M77";
export var gridSpan16 = "BusinessSupport-module--grid-span-1-6--pY9G6";
export var gridSpan17 = "BusinessSupport-module--grid-span-1-7--pj+3-";
export var gridSpan18 = "BusinessSupport-module--grid-span-1-8--1EgOp";
export var gridSpan19 = "BusinessSupport-module--grid-span-1-9--tl5t0";
export var gridSpan210 = "BusinessSupport-module--grid-span-2-10--aSw8w";
export var gridSpan211 = "BusinessSupport-module--grid-span-2-11--94NMN";
export var gridSpan22 = "BusinessSupport-module--grid-span-2-2--9yg2D";
export var gridSpan23 = "BusinessSupport-module--grid-span-2-3--IptU6";
export var gridSpan24 = "BusinessSupport-module--grid-span-2-4--iKgjf";
export var gridSpan25 = "BusinessSupport-module--grid-span-2-5--jhgzF";
export var gridSpan26 = "BusinessSupport-module--grid-span-2-6--L3blI";
export var gridSpan27 = "BusinessSupport-module--grid-span-2-7--8JPEf";
export var gridSpan28 = "BusinessSupport-module--grid-span-2-8--+pgVf";
export var gridSpan29 = "BusinessSupport-module--grid-span-2-9--RGqtX";
export var gridSpan310 = "BusinessSupport-module--grid-span-3-10--zo7ED";
export var gridSpan311 = "BusinessSupport-module--grid-span-3-11--INOPb";
export var gridSpan32 = "BusinessSupport-module--grid-span-3-2--2r22W";
export var gridSpan33 = "BusinessSupport-module--grid-span-3-3--SB765";
export var gridSpan34 = "BusinessSupport-module--grid-span-3-4--Sq1Dk";
export var gridSpan35 = "BusinessSupport-module--grid-span-3-5--8z1xW";
export var gridSpan36 = "BusinessSupport-module--grid-span-3-6--sVzm+";
export var gridSpan37 = "BusinessSupport-module--grid-span-3-7--L77-X";
export var gridSpan38 = "BusinessSupport-module--grid-span-3-8--PiXgD";
export var gridSpan39 = "BusinessSupport-module--grid-span-3-9---8rIO";
export var gridSpan410 = "BusinessSupport-module--grid-span-4-10--yUvD0";
export var gridSpan411 = "BusinessSupport-module--grid-span-4-11--is8+1";
export var gridSpan42 = "BusinessSupport-module--grid-span-4-2--pq0YV";
export var gridSpan43 = "BusinessSupport-module--grid-span-4-3--JdDK6";
export var gridSpan44 = "BusinessSupport-module--grid-span-4-4--3t6up";
export var gridSpan45 = "BusinessSupport-module--grid-span-4-5--Ux64G";
export var gridSpan46 = "BusinessSupport-module--grid-span-4-6--0NKrA";
export var gridSpan47 = "BusinessSupport-module--grid-span-4-7--PZWvQ";
export var gridSpan48 = "BusinessSupport-module--grid-span-4-8--rbIh5";
export var gridSpan49 = "BusinessSupport-module--grid-span-4-9--gWF7A";
export var gridSpan510 = "BusinessSupport-module--grid-span-5-10--JUIsY";
export var gridSpan511 = "BusinessSupport-module--grid-span-5-11--YNwHD";
export var gridSpan52 = "BusinessSupport-module--grid-span-5-2--57VI0";
export var gridSpan53 = "BusinessSupport-module--grid-span-5-3--BQ9sm";
export var gridSpan54 = "BusinessSupport-module--grid-span-5-4--RM-AK";
export var gridSpan55 = "BusinessSupport-module--grid-span-5-5--S15q5";
export var gridSpan56 = "BusinessSupport-module--grid-span-5-6--4SNUV";
export var gridSpan57 = "BusinessSupport-module--grid-span-5-7--ytb7y";
export var gridSpan58 = "BusinessSupport-module--grid-span-5-8--zuAsn";
export var gridSpan59 = "BusinessSupport-module--grid-span-5-9--BjdSc";
export var gridSpan610 = "BusinessSupport-module--grid-span-6-10--3iwLh";
export var gridSpan611 = "BusinessSupport-module--grid-span-6-11--O5sFo";
export var gridSpan62 = "BusinessSupport-module--grid-span-6-2--6akuZ";
export var gridSpan63 = "BusinessSupport-module--grid-span-6-3--pkjcs";
export var gridSpan64 = "BusinessSupport-module--grid-span-6-4--zhg8u";
export var gridSpan65 = "BusinessSupport-module--grid-span-6-5--+Ll6X";
export var gridSpan66 = "BusinessSupport-module--grid-span-6-6--YhbVk";
export var gridSpan67 = "BusinessSupport-module--grid-span-6-7--TeOGw";
export var gridSpan68 = "BusinessSupport-module--grid-span-6-8--tPUZB";
export var gridSpan69 = "BusinessSupport-module--grid-span-6-9--unR8n";
export var gridSpan710 = "BusinessSupport-module--grid-span-7-10--N7dxe";
export var gridSpan711 = "BusinessSupport-module--grid-span-7-11--Edi1N";
export var gridSpan72 = "BusinessSupport-module--grid-span-7-2--NP6Pn";
export var gridSpan73 = "BusinessSupport-module--grid-span-7-3--J9kCR";
export var gridSpan74 = "BusinessSupport-module--grid-span-7-4--abR3g";
export var gridSpan75 = "BusinessSupport-module--grid-span-7-5--5wXde";
export var gridSpan76 = "BusinessSupport-module--grid-span-7-6--C9Nmg";
export var gridSpan77 = "BusinessSupport-module--grid-span-7-7--JFCec";
export var gridSpan78 = "BusinessSupport-module--grid-span-7-8--4AMRP";
export var gridSpan79 = "BusinessSupport-module--grid-span-7-9--cfpe-";
export var gridSpan810 = "BusinessSupport-module--grid-span-8-10--JP-ng";
export var gridSpan811 = "BusinessSupport-module--grid-span-8-11--RjRYp";
export var gridSpan82 = "BusinessSupport-module--grid-span-8-2--1GTAf";
export var gridSpan83 = "BusinessSupport-module--grid-span-8-3--ZceUF";
export var gridSpan84 = "BusinessSupport-module--grid-span-8-4--vKZG-";
export var gridSpan85 = "BusinessSupport-module--grid-span-8-5--m8RlM";
export var gridSpan86 = "BusinessSupport-module--grid-span-8-6--lpEqb";
export var gridSpan87 = "BusinessSupport-module--grid-span-8-7--cDtYd";
export var gridSpan88 = "BusinessSupport-module--grid-span-8-8--23sPT";
export var gridSpan89 = "BusinessSupport-module--grid-span-8-9--4pAz6";
export var gridSpan910 = "BusinessSupport-module--grid-span-9-10--g8yVe";
export var gridSpan911 = "BusinessSupport-module--grid-span-9-11--UjqNB";
export var gridSpan92 = "BusinessSupport-module--grid-span-9-2--MgqQr";
export var gridSpan93 = "BusinessSupport-module--grid-span-9-3--pHLRK";
export var gridSpan94 = "BusinessSupport-module--grid-span-9-4--iDZ2E";
export var gridSpan95 = "BusinessSupport-module--grid-span-9-5--hHD1a";
export var gridSpan96 = "BusinessSupport-module--grid-span-9-6--odWC7";
export var gridSpan97 = "BusinessSupport-module--grid-span-9-7--BrwxP";
export var gridSpan98 = "BusinessSupport-module--grid-span-9-8--XAAUn";
export var gridSpan99 = "BusinessSupport-module--grid-span-9-9--DX9bU";
export var textBreak = "BusinessSupport-module--text-break--5KS4I";